import React from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import Number from "../../../../custom/Number";
import MonthlyIncomeTable from "./MonthlyIncomeTable";
import LoadingSpinner from "../../LoadingSpinner";
import ErrorMessage from "../../ErrorMessage";
import { resolveErrorMessage } from "../../../../util";
import AnimatedCardContent from "../../AnimatedCardContent";

const useStyles = makeStyles((theme) => ({
  title: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(2),
  },
}));

const CommissionsEarnings = ({ currentUser, user, year, getEarnings }) => {
  const classes = useStyles();
  const [earnings, setEarnings] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const params = { year };
        const data = await getEarnings(params);
        if (data?.commissionEarning <= 0) {
          throw new Error("app.earnings.noEarningsReport.commission");
        }
        setEarnings(data);
      } catch (e) {
        const messageError = resolveErrorMessage(e);
        setError(messageError);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [getEarnings, year]);

  if (loading)
    return (
      <LoadingSpinner
        marginTop={20}
        message={<FormattedMessage id="app.loading.fetching.earnings" />}
      />
    );

  if (error)
    return (
      <ErrorMessage>
        <FormattedHTMLMessage
          id={error}
          values={{ year }}
        />
      </ErrorMessage>
    );

  return (
    <>
      <AnimatedCardContent>
        <Typography
          gutterBottom
          variant="h6"
          color="primary"
          className={classes.title}
        >
          <FormattedMessage id="app.earnings.comissionHistory" />
        </Typography>
        <Typography
          gutterBottom
          variant="body2"
        >
          <FormattedHTMLMessage
            id="app.earnings.comission.description"
            values={{ year }}
          />
        </Typography>
        <Typography
          gutterBottom
          variant="body2"
        >
          <FormattedMessage id="app.earnings.comission" />
          <Number
            value={earnings?.commissionEarning}
            currency="LCT"
            taxResidence={user.taxResidence}
            hideValue={currentUser.hideValues}
          />
        </Typography>
      </AnimatedCardContent>

      <AnimatedCardContent>
        <MonthlyIncomeTable
          currentUser={currentUser}
          data={earnings?.monthlyCommissionEarnings}
          user={user}
          year={year}
          message={"app.earnings.comission.description"}
          valueLabelId="app.comission.lct"
        />
      </AnimatedCardContent>
    </>
  );
};

export default CommissionsEarnings;
